import { gql } from '@apollo/client';
import DIAGNOSIS_FRAGMENT from '../fragments/diagnosisFragment';

const STUDY_DETAILS_DRAWER_QUERY = gql`
  query studyDetailsDrawer($id: ID!) {
    study(id: $id) {
      id
      friendlyId
      info {
        interprettingPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
            country
          }
          email
        }
        referringPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
            country
          }
          email
        }
        diagnosis {
          ...DiagnosisFragment
        }
        followOnStudy {
          duration
          studyType
          reportDueDate
          cancelledReason
        }
        clinicianInitials
      }
      initDuration
      start
      stop
      studyType
      status
      reportDueDate
      rma
      studyNote
      timezone
      initialDurationOfStudy
      studyTimeOffset
      biofluxDirect {
        id
      }
      facility {
        id
        name
        contact {
          country
        }
        notificationEmail
        timezone
      }
      device {
        id
        deviceId
        firstStudyDate
      }
      linkedStudies {
        friendlyId
        initDuration
        studyType
        reportDueDate
        id
      }
      ecgDetail
      patientPaired
      patientFirstSyncDeviceAt
      initiatedTime
    }
  }

  ${DIAGNOSIS_FRAGMENT}
`;

export default STUDY_DETAILS_DRAWER_QUERY;
